<template>
  <div class="justiy-center flex items-center">
    <input
      :id="`checkbox-${item.key}`"
      type="checkbox"
      :checked="isSelected"
      class="custom-checkbox-input"
      :disabled="disabled"
      @change="$emit('toggle')"
    />
    <label
      :for="`checkbox-${item.key}`"
      class="custom-checkbox-label"
      :class="{ disabled: disabled }"
    >
      <div class="custom-checkbox-box">
        <svg
          v-if="isSelected"
          class="custom-checkbox-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="6"
          viewBox="0 0 8 6"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.66903 0.256714C8.07954 0.626173 8.11282 1.25846 7.74336 1.66897L4.14336 5.66897C3.79855 6.05209 3.21902 6.11037 2.80484 5.80357L0.404836 4.02579C-0.0389565 3.69705 -0.132229 3.0708 0.196506 2.627C0.525241 2.18321 1.1515 2.08994 1.59529 2.41867L3.26486 3.65539L6.25677 0.331044C6.62623 -0.0794662 7.25852 -0.112745 7.66903 0.256714Z"
            fill="#374053"
          />
        </svg>
      </div>
      <span
        class="font-normal text-steel-900"
        :class="textSize"
      >
        {{ item.label }}
      </span>
      <div class="tooltip-wrapper">
        <InfoTooltip
          v-if="item.tooltip"
          :text="item.tooltip"
          color-scheme="dark"
          content=""
          class="absolute"
          style="top: 50%; transform: translateY(-30%); margin-left: -10px"
          size="md"
          content-width-class="w-64"
        >
          <p v-html="item.tooltip"></p>
        </InfoTooltip>
      </div>
    </label>
  </div>
</template>

<script>
import InfoTooltip from '@/components/InfoTooltip.vue';

export default {
  name: 'CustomCheckbox',
  components: {
    InfoTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    textSize: {
      type: String,
      default: 'text-sm',
    },
  },
  emits: ['toggle'],
};
</script>

<style scoped>
.custom-checkbox-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.custom-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.custom-checkbox-label.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.custom-checkbox-box {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  background-color: theme('colors.steel.100');
  border-color: theme('colors.steel.40');
}

.custom-checkbox-box {
  border-color: rgba(31, 36, 46, 0.14);
  @apply bg-steel-100;
}

.custom-checkbox-input:checked + .custom-checkbox-label .custom-checkbox-box {
  background-color: theme('colors.sun.400');
  border-color: theme('colors.sun.400');
}

.custom-checkbox-icon {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.custom-checkbox-input:checked + .custom-checkbox-label .custom-checkbox-icon {
  opacity: 1;
}

.custom-checkbox-label:hover:not(.disabled) .custom-checkbox-box {
  transform: scale(1.05);
}

.custom-checkbox-label:focus-within .custom-checkbox-box {
  outline: 2px solid theme('colors.blue.500');
  outline-offset: 2px;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
  width: 0;
  height: 0;
}
</style>
